import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quotes, ArrowLeft, ArrowRight } from "@phosphor-icons/react";

const TESTIMONIALS = [
    {
        quote:
            "Windermere's chartering desk has consistently delivered flexibility and precision on our Asia–Europe corridors. Their post-fixture reporting is the cleanest we've seen.",
        name: "Dr. Helena Reiss",
        title: "VP, Energy Logistics — Northwind Trading",
    },
    {
        quote:
            "Their offshore support team handled our deepwater campaign with discipline. Crew quality, vessel uptime and HSE — all exceptional.",
        name: "Capt. Anand Rao",
        title: "Head of Offshore Operations — Meridian E&P",
    },
    {
        quote:
            "From newbuild supervision to a complex drydock, Windermere ran the program like an in-house team. We extended the contract twice.",
        name: "Mei Lin Tan",
        title: "Director, Fleet — Pacific Bulkers Ltd",
    },
];

export default function Testimonials() {
    const [idx, setIdx] = useState(0);
    const next = () => setIdx((i) => (i + 1) % TESTIMONIALS.length);
    const prev = () => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

    useEffect(() => {
        const t = setInterval(next, 7000);
        return () => clearInterval(t);
    }, []);

    const t = TESTIMONIALS[idx];

    return (
        <section data-testid="testimonials" className="relative py-24 md:py-32 bg-[#040914]">
            <div className="wms-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-5">
                    <span className="wms-overline">Testimony — 07</span>
                    <h2 className="mt-5 font-display font-light text-4xl md:text-5xl leading-tight tracking-tight">
                        Trusted by trading houses, NOCs and operators.
                    </h2>
                    <p className="mt-6 text-white/55 leading-relaxed">
                        Decades of fixtures, drydocks and offshore campaigns — and the long-term partnerships that come with them.
                    </p>
                    <div className="mt-10 flex items-center gap-3">
                        <button
                            onClick={prev}
                            data-testid="testimonial-prev"
                            aria-label="Previous testimonial"
                            className="w-12 h-12 inline-flex items-center justify-center border border-white/15 text-white hover:border-[#48CAE4] hover:text-[#48CAE4] transition"
                        >
                            <ArrowLeft size={16} />
                        </button>
                        <button
                            onClick={next}
                            data-testid="testimonial-next"
                            aria-label="Next testimonial"
                            className="w-12 h-12 inline-flex items-center justify-center border border-white/15 text-white hover:border-[#48CAE4] hover:text-[#48CAE4] transition"
                        >
                            <ArrowRight size={16} />
                        </button>
                        <span className="ml-3 text-xs tracking-[0.28em] uppercase text-white/40">
                            {String(idx + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
                        </span>
                    </div>
                </div>

                <div className="lg:col-span-7 relative min-h-[260px]">
                    <Quotes weight="duotone" size={56} className="text-[#48CAE4]/60" />
                    <AnimatePresence mode="wait">
                        <motion.blockquote
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.4 }}
                            className="mt-6"
                        >
                            <p className="font-display text-2xl md:text-3xl leading-snug tracking-tight text-white">
                                "{t.quote}"
                            </p>
                            <footer className="mt-8 pt-6 border-t border-white/10">
                                <div className="font-display text-base text-white">{t.name}</div>
                                <div className="text-sm text-white/55">{t.title}</div>
                            </footer>
                        </motion.blockquote>
                    </AnimatePresence>
                </div>
            </div>
        </section>
    );
}
